var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{attrs:{"label":_vm.$t('MemberId')}},[_c('b-input',{attrs:{"value":_vm.memberId ? _vm.memberId : _vm.$t('SystemGenerated'),"disabled":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }